<template>
  <v-select
    class="inline-select"
    :style="{ width: width, maxWidth: width }"
    :value="value"
    hide-details
    append-icon="expand_more"
    :items="options"
    :menu-props="{ maxHeight: '400px', offsetY: true }"
    :disabled="disabled"
    @change="$emit('change', $event)"
  >
    <template slot="selection" slot-scope="data">
      <span class="item-text">{{ data.item.text }}</span>
    </template>
  </v-select>
</template>

<script>
export default {
  name: 'InlineSelect',
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: {
      type: [Number, String],
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: '92px',
    },
    options: {
      type: Array,
      required: true,
      validator: (value) => {
        return value.every(
          (item) =>
            item &&
            typeof (item.text === 'string' || item.text === 'number') &&
            typeof (item.value === 'string' || item.value === 'number') &&
            item.value !== undefined
        )
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.inline-select {
  padding: 0;
  margin: 0;
  color: $marca-0-l40 !important;

  .item-text {
    color: $marca-0-l40 !important;
    font-size: 14px;
  }

  ::v-deep .v-icon {
    color: $marca-0-l40 !important;
    font-size: 20px;
  }

  ::v-deep .v-input__slot:before {
    border-width: 0 !important;
  }

  ::v-deep .v-input__slot:after {
    border-width: 0 !important;
  }
}
</style>
